import React from 'react';
import './TipoClienteDetails.css';

const TipoClienteDetails = ({ tipoCliente }) => {
  // Helper function to format currency
  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);
  };

  // Helper function to format date
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return 'N/A';
      
      return date.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    } catch (error) {
      return 'N/A';
    }
  };

  if (!tipoCliente) {
    return <div className="no-data">Nenhum tipo de cliente selecionado</div>;
  }

  return (
    <div className="tipo-cliente-details">
      <div className="details-section">
        <h4>Informações Gerais</h4>
        <div className="details-grid">
          <div className="details-item">
            <span className="details-label">Nome:</span>
            <span className="details-value">{tipoCliente.nome}</span>
          </div>
          <div className="details-item">
            <span className="details-label">Status:</span>
            <span className={`status-badge ${tipoCliente.ativo ? 'status-ativo' : 'status-inativo'}`}>
              {tipoCliente.ativo ? 'Ativo' : 'Inativo'}
            </span>
          </div>
          <div className="details-item">
            <span className="details-label">Data de Cadastro:</span>
            <span className="details-value">{formatDate(tipoCliente.createdAt)}</span>
          </div>
          <div className="details-item">
            <span className="details-label">Última Atualização:</span>
            <span className="details-value">{formatDate(tipoCliente.updatedAt)}</span>
          </div>
        </div>
      </div>

      <div className="details-section">
        <h4>Serviços Inclusos</h4>
        {tipoCliente.servicos && tipoCliente.servicos.length > 0 ? (
          <div className="servicos-details-list">
            {tipoCliente.servicos.map((servico, index) => (
              <div key={index} className="servico-detail-item">
                <span className="servico-nome">{servico.nome}</span>
                <span className="servico-valor">{formatCurrency(servico.valor)}</span>
              </div>
            ))}
          </div>
        ) : (
          <div className="no-servicos">
            Nenhum serviço cadastrado para este tipo de cliente.
          </div>
        )}
      </div>
    </div>
  );
};

export default TipoClienteDetails;
